/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ServiceLocationSeoFieldsAdmin } from './ServiceLocationSeoFieldsAdmin'
import {
  ServiceLocationSeoFieldsAdminFromJSON,
  ServiceLocationSeoFieldsAdminFromJSONTyped,
  ServiceLocationSeoFieldsAdminToJSON,
} from './ServiceLocationSeoFieldsAdmin'

/**
 *
 * @export
 * @interface PaginatedServiceLocationSeoFieldsAdmin
 */
export interface PaginatedServiceLocationSeoFieldsAdmin {
  /**
   *
   * @type {Array<ServiceLocationSeoFieldsAdmin>}
   * @memberof PaginatedServiceLocationSeoFieldsAdmin
   */
  results: Array<ServiceLocationSeoFieldsAdmin>
  /**
   *
   * @type {number}
   * @memberof PaginatedServiceLocationSeoFieldsAdmin
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof PaginatedServiceLocationSeoFieldsAdmin
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedServiceLocationSeoFieldsAdmin
   */
  previous: string | null
}

/**
 * Check if a given object implements the PaginatedServiceLocationSeoFieldsAdmin interface.
 */
export function instanceOfPaginatedServiceLocationSeoFieldsAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'results' in value
  isInstance = isInstance && 'count' in value
  isInstance = isInstance && 'next' in value
  isInstance = isInstance && 'previous' in value

  return isInstance
}

export function PaginatedServiceLocationSeoFieldsAdminFromJSON(
  json: any,
): PaginatedServiceLocationSeoFieldsAdmin {
  return PaginatedServiceLocationSeoFieldsAdminFromJSONTyped(json, false)
}

export function PaginatedServiceLocationSeoFieldsAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedServiceLocationSeoFieldsAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    results: (json['results'] as Array<any>).map(ServiceLocationSeoFieldsAdminFromJSON),
    count: json['count'],
    next: json['next'],
    previous: json['previous'],
  }
}

export function PaginatedServiceLocationSeoFieldsAdminToJSON(
  value?: PaginatedServiceLocationSeoFieldsAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    results: (value.results as Array<any>).map(ServiceLocationSeoFieldsAdminToJSON),
    count: value.count,
    next: value.next,
    previous: value.previous,
  }
}
